import {
  fillMissingDates,
  therapyPlaningResponseMapper,
} from 'src/components/therapyPlanning_2.0/commonComponent/converttherapyPlaningResponse';
import {
  findPlanningByDisciplineAndTherapyType,
  getDisciplineByMap,
  updateDiscipleByMap,
  updatePlanMinutes,
  updateTherapyData,
  updateTherapyDataByDate,
  updateTherapyDataByDateManual,
} from 'src/components/therapyPlanning_2.0/commonComponent/updateSingleCellData';
import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
  GET_DATA_THERAPY_PLANNING_REQUEST_2_0,
  GET_DATA_THERAPY_PLANNING_SUCCESS_2_0,
  GET_DATA_THERAPY_PLANNING_FAILURE_2_0,
  GET_DATA_THERAPY_PLANNING_LOADING_2_0,
  GET_DATA_THERAPY_PLANNING_RESET_2_0,
  ADD_SINGLE_THERAPY_PLANNING_2_0,
} = therapyPlanningAction;

const intitialstate: any = {
  response: null,
  loading: false,
  isTherapyPlanning: false,
  therapyPlaningFormattedData: null,
  totalTimeSummary: [],
};

export const getTherapyPlanningDataReducer_2_0 = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_DATA_THERAPY_PLANNING_SUCCESS_2_0: {
      if (action?.payload?.source === 'GET_WEEKLY') {
        return {
          ...state,
          response: action.payload,
          loading: false,
          isTherapyPlanning: true,
          therapyPlaningFormattedData: therapyPlaningResponseMapper(
            action?.payload?.response?.data?.length ? action?.payload?.response?.data : [],
            action?.payload?.requestPayload?.startDate,
            action?.payload?.requestPayload?.endDate
          ),
          totalTimeSummary: fillMissingDates(
            action?.payload?.response?.data?.length ? action?.payload?.response?.data : [],
            action?.payload?.requestPayload?.startDate,
            action?.payload?.requestPayload?.endDate
          ),
        };
      } else {
        return {
          ...state,
          loading: false,
          therapyPlaningFormattedData: updateTherapyData(
            state?.therapyPlaningFormattedData,
            action?.payload?.requestPayload?.startDate,
            action?.payload?.disciplineToUpdate,
            action?.payload?.groupType,
            findPlanningByDisciplineAndTherapyType(
              action?.payload?.response?.data,
              getDisciplineByMap(action?.payload?.disciplineToUpdate),
              action?.payload?.groupType
            )
          ),
          totalTimeSummary: updateTherapyDataByDate(
            state?.totalTimeSummary,
            action?.payload?.requestPayload?.startDate,
            action?.payload?.response?.data?.[0]
          ),
        };
      }
    }

    case GET_DATA_THERAPY_PLANNING_FAILURE_2_0:
      return {
        ...state,
        response: action.payload,
        therapyPlaningFormattedData: null,
        loading: false,
        isTherapyPlanning: false,
      };

    case ADD_SINGLE_THERAPY_PLANNING_2_0:
      return {
        ...state,
        therapyPlaningFormattedData: updatePlanMinutes(
          state?.therapyPlaningFormattedData,
          action?.payload?.therapyType,
          action?.payload?.groupType,
          action?.payload?.localDate,
          action?.payload?.planMinutes
        ),
        totalTimeSummary: updateTherapyDataByDateManual(
          state?.totalTimeSummary,
          action?.payload?.localDate,
          action?.payload?.planMinutes
        ),
      };

    case GET_DATA_THERAPY_PLANNING_LOADING_2_0:
      return {
        ...state,
        loading: true,
      };

    case GET_DATA_THERAPY_PLANNING_RESET_2_0:
      return intitialstate;

    default:
      return state;
  }
};
